// extracted by mini-css-extract-plugin
module.exports = {"radioGroup":"screen-setting_radioGroup_3Y6fn","tipText":"screen-setting_tipText_d56y7"};